/// <amd-module name="Tfs/Frame/Components/Header/TopLevelHeader" />
import * as React from "react";

import { Components, RegionComponent, VssComponent } from "VSS/Platform/Layout";
import { WithHeaderProgressBar } from "./WithHeaderProgressBar";

import { FocusZone, FocusZoneDirection } from "VSSUI/FocusZone";

class TopLevelHeader extends VssComponent<{}> {
    public render(): JSX.Element {
        return (
            <FocusZone circularNavigation={true} direction={FocusZoneDirection.Horizontal} focusGroupProps={{ defaultElementId: "suite-logo" }}>
                <div className="top-level-header flex-row flex-noshrink" role="navigation">
                    <WithHeaderProgressBar>
                        <RegionComponent className="flex-row flex-grow" componentRegion="header" role="navigation" />
                        <RegionComponent className="flex-row flex-noshrink" componentRegion="header-menubar" role="menubar" />
                    </WithHeaderProgressBar>
                </div>
            </FocusZone>
        );
    }
}

Components.add("ms.vss-tfs-web.frame.top-level-header", TopLevelHeader);
